var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"action-close",attrs:{"icon":"","large":"","color":"white"},on:{"click":function($event){return _vm.$emit('input', false)}}},[_c('v-icon',[_vm._v("mdi-close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }